import axios from "axios"
import {isValidForm, checkAgreement, checkInput, formMethod} from "../../helpers"

$(document).ready(function() {

    const $formBase = $(".js-form-base"),
        $modal = $(".js-modal-alert");

    $formBase.each(function(){

        const $form = $(this),
            $button = $form.find(".js-form-send"),
            $agreementNode = $form.find("[name=agreement]");

        let url = $form.attr("action");

        checkAgreement($agreementNode, $button);
        checkInput($form);

        $form.on("submit", function(e){

            e.preventDefault();

            let formData =  $form.serialize();

            if(isValidForm($form)){
                axios({
                    url: url,
                    data: formData,
                    method: formMethod("post"),
                    headers: {"Content-Type": "application/x-www-form-urlencoded"},
                }).then(res => {

                    if(res.data.success){
                        $modal.find (".js-modal-title").html("Спасибо!");

                        const $modalForm = $(".js-modal-form");

                        if($modalForm.length > 0){

                            $(".js-modal-form").addClass("fade-out")
                                .removeClass("fade-in");

                            setTimeout(() => {
                                $(".js-modal-form").removeClass("opened");
                            },500);
                        }

                    }else{
                        $modal.find (".js-modal-title").html();

                        if(Object.keys(res.data.error.errors).length > 0){

                            for(let key of Object.keys(res.data.error.errors)){

                                $form.find("[name="+key+"]").addClass("invalid")
                                    .siblings(".error").text(res.data.error.errors[key]);
                            }
                        }
                    }

                    $modal.find (".js-modal-text").html(res.data.message);
                    $modal.addClass("fade-in opened")
                        .removeClass("fade-out");

                }).catch(() => {
                    alert("Что-то пошло не так...\nПопробуйте обновить страницу");
                });
            }
        });
    });
});
